
  <div class="payment-history-wrap" [class.mobile]="deviceService.isMobile()">
<!--    <div class="title-wrap">-->
<!--      <app-transactions-filter (onChange)="changeProvider($event)"></app-transactions-filter>-->
<!--    </div>-->

    <div [formGroup]="form" class="filter">
      <app-filter-content [tabs]="tabs" [activeTab]="selectedTab" (onSelect)="goTab($event)"></app-filter-content>

      <div class="date-filter">
        <div class="date">
        <on-ui-date formControlName="from"
                    [inputDisplayed]="false"
                    (changed)="onChangedStartDate($event)">
          <div class="view-date">
            {{'transaction-history.operations-from' | customLocale}}: {{form.get('from').value | dfnsFormat: 'dd MMMM yyyy'}}
            <app-icon class="btn-arrow-ico" width="11" height="6" icon="angle-arrow"></app-icon>
          </div>
        </on-ui-date>
        <app-icon *ngIf="form.get('from').value" class="reset-date" width="20" height="20" icon="close" (click)="resetDateFilter('from')"></app-icon>
        </div>

        <div class="date">
        <on-ui-date formControlName="to"
                    [inputDisplayed]="false"
                    [min]="form.get('from').value"
                    (changed)="onChangedEndDate($event)">
          <div class="view-date">
            {{'transaction-history.operations-to' | customLocale}}: {{form.get('to').value | dfnsFormat: 'dd MMMM yyyy'}}
            <app-icon class="btn-arrow-ico" width="11" height="6" icon="angle-arrow"></app-icon>
          </div>
        </on-ui-date>
          <app-icon *ngIf="form.get('to').value" class="reset-date" width="20" height="20" icon="close" (click)="resetDateFilter('to')"></app-icon>
        </div>
      </div>

<!--      <div class="search-wrap" [class.on-focus]="isFocus">-->
<!--        <app-icon class="search-content-icon" icon="search"></app-icon>-->
<!--        <input type="text"-->
<!--               class="search-input"-->
<!--               formControlName="search_term"-->
<!--               (focus)="onFocus()"-->
<!--               (blur)="onFocus()"-->
<!--               [placeholder]="'transaction-history.search-placeholder' | customLocale"/>-->
<!--        <app-icon width="12" height="12" class="search-icon-close"-->
<!--                  [class.visible]="!!form.get('search_term').value"-->
<!--                  (click)="clearSearchForm()"-->
<!--                  icon="close-search">-->
<!--        </app-icon>-->
<!--      </div>-->
    </div>

    <ng-container *ngIf="!transactions.loaded">
      <loading-game [size]="50" class="icon"></loading-game>
    </ng-container>
    <ng-container *ngIf="transactions.loaded">
      <ng-template [ngIf]="transactions.items.length" [ngIfElse]="noContentStub">
        <div class="history-wrap">
          <app-payment-history [history]="transactions.items"></app-payment-history>
        </div>
        <div class="paginator-wrap" [class.mobile]="true || deviceService.isMobile()">
          <app-paginator [pagination]="pagination" (pageChanged)="loadPageTransaction($event)"></app-paginator>
        </div>
      </ng-template>
    </ng-container>


    <ng-template #noContentStub>
      <app-no-content-stub
        [icon]="'stub-billing-history'"
        [text]="'subscription-plans.stub-billing-history'">
      </app-no-content-stub>
    </ng-template>
  </div>


